import UserAvatarController from './user-persona.controller';
import { IUserPersona } from './user-persona.model';

const UserPersona = (props: IUserPersona) => {
  return <UserAvatarController {...props} />;
};

export default UserPersona;
